import type { LegacyRef } from 'react'
import { forwardRef } from 'react'
import classnames from 'classnames'
import noop from '@/root/utils/noop'

type Props = {
  defaultOptionText?: string
  label?: string
  labelClassName?: string
  onChangeSelection?: (e: string, v: string) => void
  placeholder?: string
  rest?: unknown[]
  formKey?: string
  options?: string[]
  selectClassName?: string
}

const Dropdown = forwardRef(
  (props: Props, ref: LegacyRef<HTMLSelectElement>) => {
    const {
      defaultOptionText = 'Select an option',
      label,
      labelClassName = '',
      selectClassName = '',
      onChangeSelection = noop,
      placeholder = 'Enter Value',
      formKey = '',
      options = [],
      ...rest
    } = props
    return (
      <div className="flex flex-col">
        {label && (
          <label
            className={classnames(
              'mb-1 w-full pl-2',
              'cursor-pointer',
              'text-brand-grey-base text-sm font-normal',
              labelClassName,
            )}
            htmlFor={label}
          >
            {label}
          </label>
        )}
        <select
          className={classnames(
            'h-12 w-full',
            'rounded-lg border-0',
            'bg-grey-bg ',
            selectClassName,
          )}
          id={label}
          placeholder={placeholder}
          onChange={e => {
            onChangeSelection(e.target.value, formKey)
          }}
          {...rest}
          ref={ref}
        >
          <option value="" disabled selected>
            {defaultOptionText}
          </option>
          {options.map((item, index) => {
            return (
              <option key={index + 1} value={item}>
                {item}
              </option>
            )
          })}
        </select>
      </div>
    )
  },
)

Dropdown.displayName = 'Dropdown'

export default Dropdown
